// @flow
import React, { createRef, memo } from 'react'
import classnames from 'classnames'
import I18n from 'i18n-react'
import Select from 'react-select/lib/Select'

import type { SelectItem } from '../SelectEnumRefIndex'

export type ReactSelectProps = {
  error: Object,
  name: string,
  onUpdate: () => void,
  optionComponent?: Function,
  options: Array<SelectItem>,
  preferredOptionHeightInPx: number,
  value: string,
}

const ReactSelect = ({
  error,
  name,
  onUpdate,
  optionComponent,
  options,
  preferredOptionHeightInPx,
  value,
}: ReactSelectProps) => {
  const selectRef = createRef()

  const handleOnBlur = () => {
    // noinspection JSUnresolvedFunction
    selectRef.current.selectFocusedOption()
  }

  const handleOnChange = (item: SelectItem) => {
    if (item.value) {
      onUpdate(item.value)
    }
  }

  return (
    <div className={getCssClasses(error)}>
      <Select
        clearAllText={I18n.translate('stringEnum.clearAllText')}
        clearValueText={I18n.translate('stringEnum.clearValueText')}
        clearable={false}
        menuStyle={getMenuStyles(options, preferredOptionHeightInPx)}
        name={name}
        noResultsText={I18n.translate('stringEnum.noResultsText')}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        optionComponent={optionComponent}
        options={options}
        placeholder={I18n.translate(`select.${name}.placeholder`, {notFound: I18n.translate('stringEnum.placeholder')})}
        ref={selectRef}
        searchPromptText={I18n.translate('stringEnum.searchPromptText')}
        value={value}
      />

      {error}
    </div>
  )
}

export const getCssClasses = (error: Object): Array<string> => {
  const classes = ['react-select']

  if (error) {
    classes.push('is-invalid')
  }

  return classnames(classes)
}

export const getMenuStyles = (options: Array<SelectItem>, optionHeightInPixels: number): Object => {
  const height = getPreferredOptionsCount(options) * optionHeightInPixels

  return height > 0 ? { maxHeight: `${height}px` } : {}
}

export const getPreferredOptionsCount = (options: Array<SelectItem>): number => {
  return options.reduce((acc, option) => {
    return option.preferred ? acc + 1 : acc
  }, 0)
}

export default memo(ReactSelect)
